import React, { Component, Fragment } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import AppRoutes from './AppRoutes';
import { Home } from './components/Home';
import { Privacy } from './components/Privacy';
import { CompanyOffer } from './components/CompanyOffer';
import { Booking } from './components/Booking';
import { UserCalendar } from './components/Calendar';
import { ConfigCompany } from './components/config/Company';
import { ConfigUsers } from './components/config/Users';
import { ConfigServices } from './components/config/Services';
import { ConfigResources } from './components/config/Resources';
import { ConfigCalendar } from './components/config/Calendar';
import { ConfigProfiles } from './components/config/Profiles';
import { ConfigQRcode } from './components/config/QRcode';
import { ChartDay } from './components/charts/Day';
import { ChartResource } from './components/charts/Resource';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import { ApplicationPaths, LoginActions, LogoutActions } from './components/api-authorization/ApiAuthorizationConstants';

import { Login } from './components/api-authorization/Login'
import { Logout } from './components/api-authorization/Logout'

import './custom.css'

export default class App extends Component {
  render () {
    return (
      <Layout>
        <Switch>
          <Route exact path='/' component={Home}></Route>
          <Route path='/booking/:companyId?/:serviceId?' component={Booking} />
          <Route path='/privacy' component={Privacy} />
          <Route path='/companyoffer' component={CompanyOffer} />
          <AuthorizeRoute path='/calendar/:userId?' component={UserCalendar} />
          <AuthorizeRoute path='/configcompany/:companyId?' component={ConfigCompany} />
          <AuthorizeRoute path='/configusers/:companyId?' component={ConfigUsers} />
          <AuthorizeRoute path='/configservices/:companyId?' component={ConfigServices} />
          <AuthorizeRoute path='/configresources/:companyId?' component={ConfigResources} />
          <AuthorizeRoute path='/configcalendar/:companyId?' component={ConfigCalendar} />
          <AuthorizeRoute path='/configparams/:companyId?' component={ConfigProfiles} />
          <AuthorizeRoute path='/configcharts/day/:companyId?' component={ChartDay} />
          <AuthorizeRoute path='/configcharts/resource/:companyId?' component={ChartResource} />
          <AuthorizeRoute path='/configqrcode/:companyId?' component={ConfigQRcode} />
          <Fragment>
            <Route path={ApplicationPaths.Login}><Login action={LoginActions.Login}/></Route>
            <Route path={ApplicationPaths.LoginFailed} render={() => loginAction(LoginActions.LoginFailed)} />
            <Route path={ApplicationPaths.LoginCallback}><Login action={LoginActions.LoginCallback}/></Route>
            <Route path={ApplicationPaths.Profile} render={() => loginAction(LoginActions.Profile)} />
            <Route path={ApplicationPaths.Register}><Login action={LoginActions.Register}/></Route>
            <Route path={ApplicationPaths.LogOut} render={() => logoutAction(LogoutActions.Logout)} />
            <Route path={ApplicationPaths.LogOutCallback} render={() => logoutAction(LogoutActions.LogoutCallback)} />
            <Route path={ApplicationPaths.LoggedOut} render={() => logoutAction(LogoutActions.LoggedOut)} />
          </Fragment>
        </Switch>
      </Layout>
    );
  }
}

          /*<Routes>
            {AppRoutes.map((route, index) => {
            const { element, requireAuth, ...rest } = route;
            return <Route key={index} {...rest} component={requireAuth ? <AuthorizeRoute {...rest} element={element} /> : element} />;
          })}
          </Routes>*/

function withParams(Component, history) {
  return (<Component history={history} />);
}

function loginAction(name) {
    return (<Login action={name}></Login>);
}

function logoutAction(name) {
    return (<Logout action={name}></Logout>);
}
